// @ts-ignore
/* eslint-disable */
import { request } from '@/services/transit.request';

/** Get all transit groups GET /api/v1/transit-groups */
export async function transitGroupsListWithPaging(options?: {
  [key: string]: any;
}) {
  return request<API.TransitGroupListResponseDto>('/api/v1/transit-groups', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Create a new transit group POST /api/v1/transit-groups */
export async function transitGroupsCreate(
  body: API.TransitGroupCreateRequestDto,
  options?: { [key: string]: any },
) {
  return request<API.TransitGroup>('/api/v1/transit-groups', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Update a transit group by ID PUT /api/v1/transit-groups/${param0} */
export async function transitGroupsUpdateById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitGroupsUpdateByIdParams,
  body: API.TransitGroupUpdateRequestDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.TransitGroup>(`/api/v1/transit-groups/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Delete transit groups by IDs DELETE /api/v1/transit-groups/${param0} */
export async function transitGroupsDeleteById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitGroupsDeleteByIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/transit-groups/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Remove tickets from a transit group PUT /api/v1/transit-groups/${param0}/remove-tickets */
export async function transitGroupsRemoveTickets(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitGroupsRemoveTicketsParams,
  body: API.TransitRemoveTicketsRequestDto,
  options?: { [key: string]: any },
) {
  const { groupid: param0, ...queryParams } = params;
  return request<any>(`/api/v1/transit-groups/${param0}/remove-tickets`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Add tickets to a transit group PUT /api/v1/transit-groups/add-tickets */
export async function transitGroupsAddTickets(
  body: API.AddTicketsRequestDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/transit-groups/add-tickets', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Transfer tickets between transit groups PUT /api/v1/transit-groups/transfer-tickets */
export async function transitGroupsTransferTickets(
  body: API.TransferTicketsRequestDto,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/transit-groups/transfer-tickets', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
